import { StarIcon } from '#/shared/ui/icons'

interface CarrierCellProps {
  name: string
  nameHref?: string
  onNameClick?: () => void
  nameAccessory?: React.ReactNode
  rating?: number
  reviewsCount?: number
  contactName?: string
}

function CarrierName({
  name,
  nameHref,
  onNameClick,
}: Pick<CarrierCellProps, 'name' | 'nameHref' | 'onNameClick'>) {
  const className = 'text-sm text-primary'
  if (nameHref) {
    return (
      <a href={nameHref} className={`${className} hover:underline`}>
        {name}
      </a>
    )
  }
  if (onNameClick) {
    return (
      <button
        type="button"
        onClick={onNameClick}
        className={`${className} cursor-pointer hover:underline`}
      >
        {name}
      </button>
    )
  }
  return <span className={className}>{name}</span>
}

export function CarrierCell({
  name,
  nameHref,
  onNameClick,
  nameAccessory,
  rating,
  reviewsCount,
  contactName,
}: CarrierCellProps) {
  const showRating = rating != null
  const showMeta = showRating || contactName

  return (
    <div className="flex flex-col items-start">
      <div className="flex h-7 items-center gap-1.5">
        <CarrierName
          name={name}
          nameHref={nameHref}
          onNameClick={onNameClick}
        />
        {nameAccessory}
      </div>
      {showMeta && (
        <div className="flex h-7 items-center gap-1">
          {showRating && (
            <span className="flex items-center gap-1 text-sm text-gray-500">
              <StarIcon className="size-3 shrink-0 text-orange-500" />
              {rating.toFixed(1)}
              {reviewsCount != null && ` (${reviewsCount})`}
            </span>
          )}
          {showRating && contactName && (
            <span className="text-xs text-gray-500">·</span>
          )}
          {contactName && (
            <span className="text-sm text-gray-500">{contactName}</span>
          )}
        </div>
      )}
    </div>
  )
}
